module.exports = __webpack_public_path__ + "static/media/tab-icon-reports.89d4f1d8.svg";